import user from "../data/user";
import projects from "../data/projects";
import experiences from "../data/experiences";
import works from "../data/works";
import educations from "../data/educations";
import contributions from "../data/contributions";
import seo from "../data/seo";
import en from "../data/locales/en.json";
import ja from "../data/locales/ja.json";
import ui from "../data/locales/ui";

export const sourceContent = {
  user,
  projects,
  experiences,
  works,
  educations,
  contributions,
  seo,
};
export const contentCatalogs = { en, ja };
const textFields = new Set([
  "title",
  "description",
  "detailDescription",
  "summary",
  "descriptions",
  "caption",
  "alt",
  "subtitle",
  "keywords",
]);

// IDs and image filenames keep translations attached to content when lists are reordered.
export function mapContent(value, translate, path = "", field = "") {
  if (typeof value === "string") {
    return textFields.has(field) ||
      path.endsWith("imageSource.label") ||
      ["date", "duration"].includes(field)
      ? translate(path, value, field)
      : value;
  }
  if (Array.isArray(value))
    return value.map((entry, index) => {
      const key =
        typeof entry === "object"
          ? entry.id || entry.page || entry.src?.split("/").pop()
          : index;
      return mapContent(entry, translate, `${path}.${key}`, field);
    });
  if (value && typeof value === "object")
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        mapContent(entry, translate, path ? `${path}.${key}` : key, key),
      ]),
    );
  return value;
}

export function localizeContent(locale) {
  const catalog = contentCatalogs[locale] || {};
  return mapContent(sourceContent, (key, original, field) => {
    if (["date", "duration"].includes(field))
      return original.replace(/\bPresent\b/g, ui[locale].present);
    return catalog[key] || original;
  });
}
